import { render, staticRenderFns } from "./AdminBreadcrumbs.vue?vue&type=template&id=39d33c9e&scoped=true&"
import script from "./AdminBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./AdminBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./AdminBreadcrumbs.vue?vue&type=style&index=0&id=39d33c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d33c9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
